import { SVGProps } from 'react';

export const SuperNinjaMainIcon = ({
  width = 24,
  height = 24,
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_19_3121)">
        <path
          d="M19.9992 10.0008H20C15.8414 10.0008 12.1289 11.1649 9.68437 13.4938C9.57421 13.35 9.48515 13.2274 9.42734 13.1344C9.05859 12.5469 8.62812 11.8578 8.31406 11.1625C8.25624 11.0336 8.20546 10.9125 8.16171 10.7985C8.43203 10.8649 8.75468 10.9125 9.10312 10.8899C9.43437 10.8688 9.7914 10.7547 10.1094 10.5156C10.4133 10.2875 10.5914 10.0133 10.6937 9.79377C10.8805 9.39377 10.9 8.9969 10.8977 8.75549C10.8937 8.22971 10.768 7.61487 10.6242 7.05627C10.325 5.90002 9.73124 1.71331 9.36952 0.833618L6.72656 4.90784C7.02421 5.63049 7.40468 6.65706 7.66874 7.57112C7.60703 7.55862 7.54218 7.54846 7.47578 7.53987C7.23046 7.5094 6.8664 7.50159 6.46249 7.64768C5.4789 8.00393 5.15703 8.87502 5.05781 9.41331C4.8539 10.5258 5.23593 11.6469 5.60781 12.4711C5.99687 13.3344 6.38593 13.6664 6.38593 13.6664L7.45703 14.9024L8.1039 15.4789C7.5914 16.3297 7.19609 17.2735 6.95624 18.3235C6.40937 18.0438 5.77031 17.7164 5.20937 17.3469C5.10546 17.2781 5.01015 17.2125 4.92343 17.1492C5.14453 17.1071 5.39218 17.0352 5.62343 16.9078C5.84296 16.7867 6.03515 16.5946 6.13828 16.3297C6.23671 16.0774 6.22499 15.8336 6.18749 15.6516C6.11952 15.3203 5.93671 15.0446 5.81562 14.8813C5.55312 14.5258 5.16171 14.1492 4.78437 13.8172C4.00468 13.1297 1.52109 10.4813 0.833588 10.0008L1.01015 13.6172C1.57421 14.0117 2.34687 14.5844 2.98281 15.1196C2.93359 15.1313 2.88359 15.1446 2.83281 15.161C2.64765 15.2196 2.38984 15.3321 2.18124 15.561C1.67343 16.1196 1.88046 16.8141 2.07734 17.211C2.48515 18.0313 3.30546 18.6688 3.97187 19.1078C4.66953 19.568 5.10468 19.668 5.10468 19.668L6.46093 20.161L6.7039 20.2211C6.68984 20.4649 6.66562 20.7016 6.66562 20.9539C6.66562 28.2586 12.6352 35.8336 19.9992 35.8336C27.3633 35.8336 33.3328 28.2586 33.3328 20.9539C33.3328 13.6492 27.3633 10.0008 19.9992 10.0008ZM10.7328 29.5836C10.7328 29.5836 10.7289 29.5781 10.7273 29.5758C8.72578 27.0852 7.50078 23.8797 7.50078 20.7289C7.50078 14.1297 12.875 10.8336 19.5047 10.8336C24.0187 10.8336 27.9508 12.3625 30.0008 15.4211C27.8414 12.8602 24.1976 11.5805 20.0672 11.5805C13.4375 11.5805 8.06328 14.8766 8.06328 21.4758C8.06328 24.3196 9.06093 27.2086 10.7273 29.5758C10.7297 29.5781 10.7312 29.5813 10.7336 29.5836H10.7328ZM20 30.8328C14.3844 30.8328 8.95859 26.086 8.95859 21.3133C8.95859 16.5406 14.3844 17.6 20 17.6C25.6156 17.6 31.0414 16.5406 31.0414 21.3133C31.0414 26.086 25.6156 30.8328 20 30.8328Z"
          fill="url(#paint0_linear_19_3121)"
        />
        <path
          d="M29.0344 21.6C29.5023 22.7914 28.5195 24.2117 26.8383 24.7726C25.1578 25.3328 23.4156 24.8219 22.9476 23.6297C22.4797 22.4383 23.4211 21.9453 25.1023 21.3844C26.7828 20.8234 28.5664 20.4078 29.0344 21.6ZM10.9656 21.6C10.4976 22.7914 11.4805 24.2117 13.1617 24.7726C14.8422 25.3328 16.5844 24.8219 17.0523 23.6297C17.5203 22.4383 16.5789 21.9453 14.8976 21.3844C13.2172 20.8234 11.4336 20.4078 10.9656 21.6Z"
          fill="url(#paint1_linear_19_3121)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_19_3121"
          x1="0.833588"
          y1="18.3336"
          x2="33.3328"
          y2="18.3336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E96384" />
          <stop offset="1" stopColor="#3D00FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19_3121"
          x1="10.849"
          y1="22.9163"
          x2="29.151"
          y2="22.9163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E96384" />
          <stop offset="1" stopColor="#3D00FF" />
        </linearGradient>
        <clipPath id="clip0_19_3121">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
